import * as React from "react";
import {EquipmentStatus} from "../MassiveActionsTypesAndFunctions";
import {DATA_STATE} from "../../../users/contexts/UsersDashboardContext";
import {getEquipmentStatuses} from "../MassiveActionsController";

interface ChangeEquipmentStatusContextType {
    equipmentsStatuses: {
        equipmentsStatuses: EquipmentStatus[];
        equipmentsStatusesState: DATA_STATE
    }
}

export const ChangeEquipmentStatusContext = React.createContext<ChangeEquipmentStatusContextType>(
    {} as any);

export const ChangeEquipmentStatusProvider: React.FC = ({children}) => {
    const [equipmentsStatuses, setEquipmentsStatuses] = React.useState<EquipmentStatus[]>()
    const [equipmentsStatusesState, setEquipmentsStatusesState] = React.useState<DATA_STATE>(DATA_STATE.isLoading)


    React.useEffect(() => {
        getEquipmentStatuses()
            .then(lists => setEquipmentsStatuses(lists))
            .then(() => setEquipmentsStatusesState(DATA_STATE.loaded))
            .catch(error => setEquipmentsStatusesState(DATA_STATE.error))
    }, [])

    return (
        <ChangeEquipmentStatusContext.Provider
            value={{
                equipmentsStatuses: {equipmentsStatuses, equipmentsStatusesState}
            }}
        >
            {children}
        </ChangeEquipmentStatusContext.Provider>
    );
}

